import { render, staticRenderFns } from "./Fude.vue?vue&type=template&id=ded61eee&scoped=true&"
import script from "./Fude.vue?vue&type=script&lang=js&"
export * from "./Fude.vue?vue&type=script&lang=js&"
import style0 from "./Fude.vue?vue&type=style&index=0&id=ded61eee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded61eee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ded61eee')) {
      api.createRecord('ded61eee', component.options)
    } else {
      api.reload('ded61eee', component.options)
    }
    module.hot.accept("./Fude.vue?vue&type=template&id=ded61eee&scoped=true&", function () {
      api.rerender('ded61eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/comp/Fude.vue"
export default component.exports